import { FC, useMemo } from 'react'
import classNames from 'classnames'
import styles from './ArticleSection.module.scss'
import ArticleCard from 'components/encyclopedia/article-card/ArticleCard'
import { ArticleSectionProps as Props } from './types'
import { routes } from 'utils/routes'
import { Article } from '../../types'

const ArticleSection: FC<Props> = ({ articles, title, filter, className, randomize, limit }) => {
  // Constants
  const articlesToShow = useMemo(() => {
    let tempArticles: Article[] = articles || []

    // apply filter if given
    if (filter) {
      tempArticles = tempArticles?.filter(filter)
    }

    // randomize the array if necessary
    if (randomize) {
      tempArticles = tempArticles?.sort(() => Math.random() - 0.5)
    }

    // limit the output if necessary
    if (limit) {
      tempArticles = tempArticles?.slice(0, limit)
    }

    return tempArticles
  }, [articles, filter, randomize, limit])

  return (
    <section className={classNames('container', styles['article-section'], className)}>
      <h2>{title}</h2>
      <ul className={styles['card-grid']}>
        {articlesToShow?.length ? (
          articlesToShow.map((article) => (
            <li key={article.id}>
              <ArticleCard
                article={article}
                destination={
                  routes(article.locale, '', [article.category.slug, article.subCategory.slug, article.slug]).encyclopediaArticle
                }
              />
            </li>
          ))
        ) : (
          <li>Geen artikels gevonden</li>
        )}
      </ul>
    </section>
  )
}

export default ArticleSection
